import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaArrowUp } from 'react-icons/fa';

import { Odom } from '../../HomePage/components/Highlights';
import credibleCommunicationsHighlightsArrow from '../../../assets/images/credibleCommunicationsHighlightsArrow.png';
import credibleCommunicationsHighlightsFacebook from '../../../assets/images/credibleCommunicationsHighlightsFacebook.png';
import credibleCommunicationsHighlightsPinterest from '../../../assets/images/credibleCommunicationsHighlightsPinterest.png';
import credibleCommunicationsHighlightsLinkedin from '../../../assets/images/credibleCommunicationsHighlightsLinkedin.png';
import credibleCommunicationsHighlightsBook from '../../../assets/images/credibleCommunicationsHighlightsBook.png';

const CommunicationsHighlights = () => (

  <Container fluid>
    <Row>
      <Col xs={6} md={3}>
        <Row style={{ height: '100%', paddingRight: 10, paddingLeft: 10 }}>
          <Newsletter />
        </Row>
      </Col>
      <Col xs={6} md={3}>
        <Row style={{ height: '100%', paddingRight: 10, paddingLeft: 10 }}>
          <Facebook />
        </Row>
      </Col>
      <Col xs={6} md={3}>
        <Row style={{ height: '100%', paddingRight: 10, paddingLeft: 10 }}>
          <Instagram />
        </Row>
      </Col>
      <Col xs={6} md={3}>
        <Row style={{ height: '100%', paddingRight: 10, paddingLeft: 10 }}>
          <Linkedin />
        </Row>
      </Col>
      <Col xs={6} md={6}>
        <Row style={{ height: '100%', paddingRight: 10, paddingLeft: 10 }}>
          <PressReleases />
        </Row>
      </Col>
      <Col xs={6} md={6}>
        <Row style={{ height: '100%', paddingRight: 10, paddingLeft: 10 }}>
          <Articles />
        </Row>
      </Col>
    </Row>
  </Container>
)

const Newsletter = () => (
  <Col style={{ marginTop: 20 }}>
    <Row>
      <Col style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <img
          src={credibleCommunicationsHighlightsArrow}
          style={{
            height: 'auto',
            width: 80
          }}
          alt=""
        />
      </Col>

    </Row>
    <Row style={{ marginTop: 2 }}>
      <Col style={{ backgroundColor: '#F3F5ED', marginTop: 20, padding: 20 }}>
        <Row style={{ paddingLeft: 32 }}>
          <Odom number={38}
            text="%"
            // preText="+" 
            odomStyle={{
              fontSize: 40,
              fontFamily: 'montserrat bold',
              fontWeight: 'bold',
              color: '#1B526D',
              lineHeight: 1,
              padding: 0,
            }} />
          <Col style={{ paddingLeft: 4 }}>
            <FaArrowUp
              size={36}
              color='#899D75'
            />
          </Col>
        </Row>
        <Row>
          <p style={{
            fontSize: 18,
            fontFamily: 'montserrat medium',
            // fontWeight: 'bold',
            color: '#4D788D',
            padding: 0,
            paddingLeft: 20,
            paddingRight: 20,
            lineHeight: 1.2,
            textAlign: 'center'
          }}>CSIO
        <span style={{
              fontSize: 18,
              fontFamily: 'montserrat bold',
              fontWeight: 'bold',
              color: '#14183A',
              padding: 0,
            }}> newsletter subscribers</span>
          </p>
        </Row>
      </Col>
    </Row>
  </Col>
)

const Facebook = () => (
  <Col style={{ marginTop: 20 }}>
    <Row>
      <Col style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <img
          src={credibleCommunicationsHighlightsFacebook}
          style={{
            width: 80,
            height: 'auto',
          }}
          aria-label="Facebook logo"
        />
      </Col>

    </Row>
    <Row style={{ marginTop: 6 }}>
      <Col style={{ padding: 20, marginTop: 12, minHeight: 176 }}>
      <Row style={{ paddingLeft: 32 }}>
          <Odom number={31}
            text="%"
            // preText="+" 
            odomStyle={{
              fontSize: 40,
              fontFamily: 'montserrat bold',
              fontWeight: 'bold',
              color: '#1B526D',
              lineHeight: 1,
              padding: 0,
            }} />
            <Col style={{ paddingLeft: 4 }}>
            <FaArrowUp
              size={36}
              color='#899D75'
            />
          </Col>
        </Row>
        <Row>
          <p style={{
            fontSize: 18,
            fontFamily: 'montserrat medium',
            // fontWeight: 'bold',
            color: '#4D788D',
            padding: 0,
            paddingLeft: 20,
            paddingRight: 20,
            lineHeight: 1.2,
            textAlign: 'center'
          }}>
            <span style={{
              fontSize: 18,
              fontFamily: 'montserrat bold',
              fontWeight: 'bold',
              color: '#14183A',
              padding: 0,
            }}>Facebook</span> followers
          </p>
        </Row>
      </Col>
    </Row>
  </Col>
)

const Instagram = () => (
  <Col style={{ marginTop: 20 }}>
    <Row>
      <Col style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <img
          src={credibleCommunicationsHighlightsPinterest}
          style={{
            width: 80,
            height: 'auto',
          }}
          aria-label="Instagram logo"
        />
      </Col>
    </Row>
    <Row style={{ marginTop: 8 }}>
      <Col style={{ backgroundColor: '#F3F5ED', padding: 20, marginTop: 12, minHeight: 176 }}>
      <Row style={{ paddingLeft: 32 }}>
          <Odom number={20}
            text="%"
            // preText="+" 
            odomStyle={{
              fontSize: 40,
              fontFamily: 'montserrat bold',
              fontWeight: 'bold',
              color: '#1B526D',
              lineHeight: 1,
              padding: 0,
            }} />
            <Col style={{ paddingLeft: 4 }}>
            <FaArrowUp
              size={36}
              color='#899D75'
            />
          </Col>
        </Row>
        <Row>
          <p style={{
            fontSize: 18,
            fontFamily: 'montserrat medium',
            // fontWeight: 'bold',
            color: '#4D788D',
            padding: 0,
            paddingLeft: 20,
            paddingRight: 20,
            lineHeight: 1.2,
            textAlign: 'center'
          }}>
            <span style={{
              fontSize: 18,
              fontFamily: 'montserrat bold',
              fontWeight: 'bold',
              color: '#14183A',
              padding: 0,
            }}>Instagram</span> followers
          </p>
        </Row>
      </Col>
    </Row>
  </Col>
)

const Linkedin = () => (
  <Col style={{ marginTop: 20 }}>
    <Row>
      <Col style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <img
          src={credibleCommunicationsHighlightsLinkedin}
          style={{
            width: 80,
            height: 'auto',
          }}
          aria-label="Linkedin logo"
        />
      </Col>

    </Row>
    <Row style={{ marginTop: 8 }}>
      <Col style={{ padding: 20, marginTop: 12, minHeight: 176 }}>
      <Row style={{ paddingLeft: 32 }}>
          <Odom number={48}
            text="%"
            // preText="+" 
            odomStyle={{
              fontSize: 40,
              fontFamily: 'montserrat bold',
              fontWeight: 'bold',
              color: '#1B526D',
              lineHeight: 1,
              padding: 0,
            }} />
            <Col style={{ paddingLeft: 4 }}>
            <FaArrowUp
              size={36}
              color='#899D75'
            />
          </Col>
        </Row>
        <Row>
          <p style={{
            fontSize: 18,
            fontFamily: 'montserrat medium',
            // fontWeight: 'bold',
            color: '#4D788D',
            padding: 0,
            paddingLeft: 20,
            paddingRight: 20,
            lineHeight: 1.2,
            textAlign: 'center'
          }}>
            <span style={{
              fontSize: 18,
              fontFamily: 'montserrat bold',
              fontWeight: 'bold',
              color: '#14183A',
              padding: 0,
            }}>LinkedIn</span> followers
          </p>
        </Row>
      </Col>
    </Row>
  </Col>
)

const PressReleases = () => (
  <Col style={{ marginTop: 20, padding: 20 }}>
    <Row>
      <Col xs={9}>
        <Row style={{
          // display: 'flex', flexDirection: 'row', justifyContent: 'center'
        }}>
          <Odom number={29}
            // style={{ justifyContent: 'flex-start', paddingLeft: 20 }}
            odomStyle={{
              fontSize: 40,
              fontFamily: 'montserrat bold',
              fontWeight: 'bold',
              color: '#1B526D',
              lineHeight: 1,
              padding: 0,
            }} />
        </Row>
        <Row>
          <Col>
            <p style={{
              fontSize: 18,
              fontFamily: 'montserrat medium',
              // fontWeight: 'bold',
              color: '#4D788D',
              padding: 0,
              paddingLeft: 20,
              paddingRight: 20,
              lineHeight: 1.2,
              textAlign: 'center'
            }}>
              <span style={{
                fontSize: 18,
                fontFamily: 'montserrat bold',
                fontWeight: 'bold',
                color: '#14183A',
                padding: 0,
              }}>press releases</span> to industry <span style={{
                fontSize: 18,
                fontFamily: 'montserrat bold',
                fontWeight: 'bold',
                color: '#14183A',
                padding: 0,
              }}>trade publications</span>
            </p>
          </Col>
        </Row>
      </Col>
      <Col xs={3} style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <img
          src={credibleCommunicationsHighlightsBook}
          style={{ width: '100%', height: 'auto' }}
          alt=""
        />
      </Col>
    </Row>
  </Col>
)

const Articles = () => (
  <Col style={{ marginTop: 20, padding: 20 }}>
    <Row style={{
      // display: 'flex', flexDirection: 'row', justifyContent: 'center'
    }}>
      <Odom number={20}
        // style={{ justifyContent: 'flex-start', paddingLeft: 20 }}
        odomStyle={{
          fontSize: 40,
          fontFamily: 'montserrat bold',
          fontWeight: 'bold',
          color: '#1B526D',
          lineHeight: 1,
          padding: 0,
        }} />
    </Row>
    <Row>
      <Col>
        <p style={{
          fontSize: 18,
          fontFamily: 'montserrat medium',
          // fontWeight: 'bold',
          color: '#4D788D',
          padding: 0,
          paddingLeft: 20,
          paddingRight: 20,
          lineHeight: 1.2,
          textAlign: 'center'
        }}>
          <span style={{
            fontSize: 18,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#14183A',
            padding: 0,
          }}>articles in</span> trade and association <span style={{
            fontSize: 18,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#14183A',
            padding: 0,
          }}>magazines</span>
        </p>
      </Col>
    </Row>
  </Col>
)

export default CommunicationsHighlights;
